<template>
  <sweet-modal
    ref="modal" :width="width" :title="title"
    class="modal-create-popup">
    <div class="modal-create-popup-container">
      <div v-if="step === 'type'" class="popup-type">
        <div
          :class="{'popup-type__option--selected': type === 'internal', 'popup-disabled': isBundle}"
          class="popup-type__option"
          @click="!isBundle ? setType('internal') : ''">
          <div class="popup-type__option__checkbox">
            <font-awesome-icon :icon="['fas', 'check']" size="xs"/>
          </div>
          <div class="popup-type__option__title">{{ $t("ct-modal-create-popup-option-internal-title") }}</div>
          <div class="popup-type__option__description">
            {{ $t("ct-modal-create-popup-option-internal-descrip") }}
          </div>
        </div>
        <div
          :class="{'popup-type__option--selected': type === 'external'}" class="popup-type__option"
          @click="setType('external')">
          <div class="popup-type__option__checkbox">
            <font-awesome-icon :icon="['fas', 'check']" size="xs"/>
          </div>
          <div class="popup-type__option__title">{{ $t("ct-modal-create-popup-option-external-title") }}</div>
          <div class="popup-type__option__description">
            {{ $t("ct-modal-create-popup-option-external-descrip") }}
          </div>
        </div>
      </div>
      <div v-else class="popup-config">
        <template v-if="type === 'internal'">
          <div class="popup-config__title">{{ $t("ct-modal-create-popup-config-internal-title") }}</div>
          <div class="popup-config__description">{{ $t("ct-modal-create-popup-config-internal-descrip") }}</div>
        </template>
        <template v-if="type === 'external'">
          <div class="popup-config__title">{{ $t("ct-modal-create-popup-config-external-title") }}</div>
          <div class="popup-config__description">{{ $t("ct-modal-create-popup-config-external-descrip") }}</div>
        </template>
        <div class="form-group">
          <label>{{ $t("ct-modal-create-popup-config-label-name") }} <span class="ba-color-red1">*</span></label>
          <input
            v-model="name" :placeholder="$t('ct-modal-create-popup-config-placeholder-name')"
            :class="{ 'is-invalid': dirty && !name }"
            type="text" class="form-control">
          <span class="invalid-feedback">{{ $t("ct-modal-create-popup-config-error-name") }}</span>
        </div>
        <template v-if="type === 'external'">
          <div class="form-group">
            <label>{{ $t("ct-modal-create-popup-config-label-url") }} <span class="ba-color-red1">*</span></label>
            <input
              v-model="external_url" :placeholder="$t('ct-modal-create-popup-config-placeholder-url')"
              :class="{ 'is-invalid': dirty && !(external_host && external_path) }" type="url" class="form-control">
            <span class="invalid-feedback">{{ $t("ct-modal-create-popup-config-error-url") }}</span>
          </div>
          <div class="form-group">
            <label>{{ $t("ct-modal-create-popup-config-label-script") }}</label>
            <builderall-global-script :token="token" :site="external_url"/>
          </div>
        </template>
      </div>
      <div class="text-right">
        <button
          class="btn btn-outline-light"
          @click="cancel()">{{ $t("ct-cancel") }}
        </button>
        <button
          v-if="step === 'type'" :disabled="!type" class="btn btn-primary"
          @click="next()">{{ $t("ct-next") }}
        </button>
        <template v-else>
          <button
            v-if="edit"
            class="btn btn-success"
            @click="save()">
            <i class="svg-icon svgi-save"/>
            {{ $t("ct-save") }}
          </button>
          <button
            v-else
            class="btn btn-primary"
            @click="save()">
            {{ $t("ct-next") }}
          </button>
        </template>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
import {SweetModal} from "sweet-modal-vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
  name: "ModalCreatePopupComponent",
  components: {SweetModal, FontAwesomeIcon},
  props: ["isBundle"],
  data() {
    return {
      edit: false,
      step: "type",
      type: "",
      name: "",
      external_url: "",
      external_host: null,
      external_path: null,
      dirty: false,
      token: "",
    };
  },
  computed: {
    title() {
      return this.$t(`ct-modal-create-popup-title-${this.type || "type"}`);
    },
    width() {
      return this.step === "type" ? "850px" : "650px";
    },
  },
  watch: {
    external_url() {
      try {
        const url = new URL(this.external_url);
        this.external_host = url.hostname.replace(/^www\./, '');
        this.external_path = url.pathname;
      } catch (e) {
        this.external_host = null;
        this.external_path = null;
        console.warn(e);
      }
    },
  },
  methods: {
    open(item) {
      this.syncGlobalScriptToken();

      if (item) {
        this.edit = true;
        this.step = "config";
        this.type = item.external_host && item.external_path ? "external" : "internal";
        this.name = item.name;
        if (item.external_host && item.external_path) {
          this.type = "external";
          this.external_url = `https://${item.external_host}${item.external_path}`;
        } else {
          this.type = "internal";
          this.external_url = "";
        }
      } else {
        this.edit = false;
        this.step = "type";
        this.type = this.isBundle ? "external" : "";
        this.name = "";
        this.external_url = "";
      }

      this.$refs.modal.open();
    },
    setType(type) {
      this.type = type;
    },
    next() {
      this.step = "config";
    },
    save() {
      this.dirty = true;
      if (!this.name || (this.type !== "internal" && !(this.external_host && this.external_path))) return;
      this.$emit("save", {
        name: this.name,
        external_host: this.external_host,
        external_path: this.external_path,
      });
      this.$refs.modal.close();
    },
    cancel() {
      this.$refs.modal.close();
    },
    syncGlobalScriptToken() {
      this.token = document.querySelector("builderall-appshell").getAttribute("token");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-create-popup-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 14px;
}

.popup-type {
  display: flex;
  gap: 40px;

  .popup-type__option {
    display: flex;
    padding: 20px;
    flex-direction: column;
    align-items: end;
    gap: 20px;
    flex: 1;
    align-self: stretch;
    border-radius: 8px;
    border: 1px dashed #b0bfce;
    background: #fff;
    transition: all 300ms;
    cursor: pointer;

    .popup-type__option__checkbox {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 20px;
      width: 20px;
      border: 1px solid #b4c4d7;
      border-radius: 100%;
      color: #fff;
      transition: all 300ms;
    }

    .popup-type__option__title, .popup-type__option__description {
      width: 100%;
      text-align: center;
      font-family: Mulish, sans-serif;
      font-weight: 600;
    }

    .popup-type__option__title {
      color: #434343;
      font-size: 18px;
    }

    .popup-type__option__description {
      color: #6e6e6e;
      font-size: 15px;
      min-height: 110px;
    }

    &.popup-type__option--selected {
      border: 1px solid #3099ff;

      .popup-type__option__checkbox {
        background-color: #3099ff;
        border: 1px solid lighten(#3099ff, 25%);
      }
    }

    &.popup-disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }

    &:hover {
      box-shadow: 0 6px 14px -6px rgba(24, 39, 75, 0.12);

      &, .popup-type__option__checkbox {
        border-color: #3099ff;
      }
    }
  }
}

.popup-config {
  display: flex;
  padding: 20px;
  flex-direction: column;
  gap: 20px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: #fff;

  .popup-config__title, .popup-config__description {
    text-align: center;
    font-family: Mulish, sans-serif;
    font-weight: 600;
  }

  .popup-config__title {
    color: #434343;
    font-size: 18px;
  }

  .popup-config__description {
    color: #6e6e6e;
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalCreatePopup.vue